import {dom, library} from '@fortawesome/fontawesome-svg-core';

import {definition as fasBars} from '@fortawesome/free-solid-svg-icons/faBars';
import {definition as fasCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import {definition as fasCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import {definition as fasCocktail } from '@fortawesome/free-solid-svg-icons/faCocktail';
import {definition as fasExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import {definition as fasMapMarkedAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkedAlt';
import {definition as fasPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import {definition as fasSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import {definition as fasTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

export default class FontAwesomeBuilder {
  static buildLibrary() {
    library.add(
      fasBars,
      fasCalendarAlt,
      fasCheck,
      fasCocktail,
      fasExternalLinkAlt,
      fasMapMarkedAlt,
      fasPaperPlane,
      fasSpinner,
      fasTimes
    );
    dom.watch();
  }
}
